
import {useEffect , useState , useRef} from "react"
import {BrowserRouter as Router , Routes , Route , Link } from 'react-router-dom';
import Header from "./../components/Header";
import {useNavigate} from "react-router-dom";
import { motion } from "framer-motion";
import './Main.css';

//import './index.css'

function Home () {
  const navigate = useNavigate ();
  const token=localStorage.getItem ('token');
  const phone=localStorage.getItem ('phone');
  const units=JSON.parse(localStorage.getItem ('units'));
  const select_unit=localStorage.getItem ('select_unit');

  useEffect (()=>{
  },[]);



  /*
  return (
  <div style={style.container}>
  <div style={style.content}>

  <h1 style={{textAlign:'center'}}>هوش سبز</h1>
  <h3 style={{textAlign:'center'}}>
  REFLEX ROD
  </h3>
  <button  className="btn"
  onClick={()=>{
  if (id!=null && phone!=null && units!=null && select_unit!=null)
  navigate ('/MainApp')
  else
  navigate ('/GetPhone');
}} >
وب اپلکیشن
</button>
</div>
</div>
);
*/
return (

  <div className="min-h-screen bg-slate-950 text-white">


  {/* Header */}
  <Header/>



  {/* Hero */}

  <section className="
  pt-40
  pb-32
  text-center
  px-6
  bg-gradient-to-br
  from-slate-950
  via-blue-950
  to-slate-950
  ">


  <motion.h1

  initial={{opacity:0,y:40}}

  animate={{opacity:1,y:0}}

  transition={{duration:0.8}}

  className="
  text-5xl
  md:text-6xl
  font-black
  mb-8
  "

  >

  نسل   جدید
  <span className="text-cyan-400">
  بازی های تعاملی
  </span>

  </motion.h1>



  <motion.p

  initial={{opacity:0}}

  animate={{opacity:1}}

  transition={{delay:.5}}

  className="
  max-w-3xl
  mx-auto
  text-gray-300
  text-lg
  leading-10
  "

  >

  ما طراحی و تولید تجهیزات هوشمند سرگرمی را
  با ترکیب فناوری، خلاقیت و تجربه کاربری
  برای مراکز تفریحی و تجاری انجام می‌دهیم

  </motion.p>


  {
    (token==undefined)?
    <button
    onClick={()=>navigate("/PhoneNumber")}
    className="
    mt-12
    bg-orange-500
    px-12
    py-4
    rounded-2xl
    text-lg
    hover:scale-110
    transition
    shadow-xl
    shadow-orange-500/40
    ">

    ورود به سامانه

    </button>
    :
    null
  }


  </section>





  {/* Products */}

  <section className="
  py-24
  px-8
  ">


  <h2 className="
  text-4xl
  text-center
  font-bold
  mb-16
  ">

  خدمات ما

  </h2>



  <div className="
  grid
  md:grid-cols-3
  gap-10
  max-w-6xl
  mx-auto
  ">


  {
    [
      {
        title:"پشتیبانی",
        text:"ارتباط با کادر پشتیبانی مجموعه"
      },
      {
        title:"تجهیزات تعاملی",
        text:"طراحی بازی‌های جدید برای مراکز سرگرمی."
      },
      {
        title:"مدیریت آنلاین",
        text:"کنترل دستگاه‌ها و گزارش‌گیری لحظه‌ای."
      }

    ].map((item,index)=>(


      <motion.div

      whileHover={{scale:1.05}}

      key={index}

      className="
      bg-slate-900
      p-8
      rounded-3xl
      border
      border-slate-700
      hover:border-cyan-400
      transition
      "

      >


      <h3 className="
      text-2xl
      text-cyan-400
      mb-5
      ">

      {item.title}

      </h3>


      <p className="text-gray-300 leading-8">

      {item.text}

      </p>


      </motion.div>


    ))

  }


  </div>

  </section>





  {/* Why */}

  <section className="
  bg-slate-900
  py-24
  px-8
  text-center
  ">


  <h2 className="
  text-4xl
  font-bold
  mb-12
  ">

  چرا MEGA GAMES?

  </h2>



  <div className="
  grid
  md:grid-cols-4
  gap-8
  max-w-5xl
  mx-auto
  ">


  {
    [
      "طراحی اختصاصی",
      "تولید هوشمند",
      "مدیریت ابری",
      "پشتیبانی آنلاین"
    ]
    .map((x,i)=>(

      <div

      key={i}

      className="
      bg-slate-950
      rounded-2xl
      p-6
      hover:-translate-y-2
      transition
      border
      border-slate-800
      hover:border-cyan-400
      "

      >

      {x}

      </div>


    ))

  }


  </div>


  </section>





  {/* Footer */}


  <footer className="
  py-10
  text-center
  bg-black
  text-gray-400
  ">


  <h3 className="
  text-xl
  text-cyan-400
  mb-3
  ">

  MEGA GAMES

  </h3>


  <p>
  سیستم‌های هوشمند سرگرمی
  </p>


  <p className="mt-5 text-sm">
  © 2026 All Rights Reserved
  </p>
  <div className="text-center">

  <a
   className="block w-fit mx-auto"
    rel="noreferrer"
    referrerPolicy='origin'
    target='_blank'
    href='https://trustseal.enamad.ir/?id=7263367&Code=kfrXKFiaCGwZgrSaYrcdOEoohq1F04zJ'>
      <img
        referrerPolicy='origin'
        src='https://trustseal.enamad.ir/logo.aspx?id=7263367&Code=kfrXKFiaCGwZgrSaYrcdOEoohq1F04zJ'
        alt=''
        style={{cursor:'pointer'}} />
   </a>
   </div>

  </footer>



  </div>

);


}

const style={
  container:{
    //  minHeight:"100vh",
    display:"flex",
    alignItems:"center",
    padding:16,
    //    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
    maxWidth:420,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
    //    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
    //  backgroundColor:"#1976d2",
    coloe:"#fff",
    //    cursor:"pointer"
  }

}


export default Home;
